export default function({language}) {

    var config = {
        label: language["company-label"],
        placeholder: language["company-placeholder"],
        validators: ["mandatory", "minChars:2"]
    };

    return {
        config,
        extendsType: "text-field"
    };
};
